import React from 'react';
import PropTypes from 'prop-types';

function Check({ className, style }) {
  return (
    <svg className={className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.99991 16.17L4.82991 12L3.40991 13.41L8.99991 19L20.9999 6.99997L19.5899 5.58997L8.99991 16.17Z" fill="#525252"/>
    </svg>
  )
}

Check.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
}

export default Check;
